import React from 'react';
import { Link  as MyLink } from '@mui/material';

export default function Link({ ...props }: Parameters<typeof MyLink>[0]) {
    return (
        <MyLink {...props} />
    );
}
